import { render, staticRenderFns } from "./servisne-operacije.editor.vue?vue&type=template&id=5795b63f&scoped=true&"
import script from "./servisne-operacije.editor.vue?vue&type=script&lang=ts&"
export * from "./servisne-operacije.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795b63f",
  null
  
)

export default component.exports